<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <div style="float: left">
            <el-button
              v-access:add
              icon="el-icon-plus"
              @click="add"
              size="small"
              :disabled="isloading"
              >新增
            </el-button>
          </div>
          <div style="float: right">
            <OfSearch
              @search="search"
              style="float: left; padding-right: 5%"
              :placeholder="placeholder"
            ></OfSearch>
            <el-button type="danger" @click="loadData">查询</el-button>
          </div>
        </el-row>
      </div>
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Id"
            label="项目编号"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="Title"
            label="标题"
            align="left"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="进展时间" width="140" align="center">
            <template slot-scope="scope">
              {{ (scope.row.ActivityTime * 1000) | formatDate }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑
              </el-button>
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情
              </el-button>
              <el-button
                v-access:delete
                @click="innerDel(scope.row)"
                type="text"
                size="mini"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <OfPagination
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
    </BasePage>
    <ModulepPogresse
      v-if="formVisible"
      :dataFormProg="dataFormProg"
      :isDisabled="isEdit"
      :formTitleProg="formTitleProg"
      @formCallBack="formCallBack"
    >
    </ModulepPogresse>
    <ModulepQuery
      v-if="formVisibleQuery"
      :dataFormProg="dataFormProg"
      :isDisabled="isEdit"
      :formTitleProg="formTitleProg"
      @formCallBack="formCallBack"
    >
    </ModulepQuery>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModulepPogresse from "@/modules/zjrc/pages/material/implementproject/progress/edit";
import ModulepQuery from "@/modules/zjrc/pages/material/implementproject/progress/query";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null,
    },
    ImplementId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isloading: false,
      headerRow: "header-row",
      listData: [],
      placeholder: "标题",

      total: 0,
      currentPage: 1,
      pageSize: 15,

      formData: [],
      isEdit: false,
      formVisible: false,
      formVisibleQuery: false,

      formTitleProg: "",
      dataFormProg: [],

      // ImplementId: "", //项目Id
    };
  },
  mounted() {
    let that=this;
    // that.ImplementId = that.$route.query.Id;
    that.loadData();
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModulepPogresse,
    ModulepQuery,
  },
  methods: {
    //搜索
    search(keyword) {
      this.searchModel.searchKey = keyword;
      this.currentPage = 1;
      this.loadData()
    },
    //初始化数据
    loadData() {
      let that=this;
      that.isloading = true;
      let params = {
        PageIndex: that.currentPage,
        PageSize: that.pageSize,
        Id: that.ImplementId
      };
      api.QueryImplementSchedule(params).then((rep) => {
        if (rep.data.Code === 0) {
          that.total = rep.data.Data.total;
          var data = rep.data.Data.rows;
          that.listData = data;
          that.isloading = false;
        }
      });
    },
    add() {
      let that=this;
      that.isEdit = false;
      that.formTitleProg = "新增项目进度";
      that.dataFormProg = {};
      that.dataFormProg.ImplementId = that.ImplementId;
      that.formVisible = true;
    },
    innerEdit(rowData) {
      this.isEdit = true;
      this.formTitleProg = "编辑项目进度";
      this.dataFormProg = Object.assign({}, rowData);
      this.dataFormProg.ActivityTime = rowData.ActivityTime * 1000;
      this.formVisible = true;
    },
    innerRead(rowData) {
      this.isEdit = true;
      this.formTitleProg = "详情";
      this.dataFormProg = Object.assign({}, rowData);
      this.dataFormProg.ActivityTime = rowData.ActivityTime * 1000;
      this.formVisibleQuery = true;
    },
    innerDel(rowData) {
      this.$confirm("请确认是否删除选中的数据？", "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        rowData.IsDeleted = 1;
        let params = Object.assign({}, rowData);
        api
          .DelScheduleImplementProject(params)
          .then((rep) => {
            if (rep.data.Code === 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.currentPage = 1;
              this.loadData();
            } else {
              this.$message({
                message: rep.data.Message,
                type: "error",
              });
            }
          })
          .catch((e) => {
            this.$message({
              message: e.toString(),
              type: "error",
            });
          });
      });
      //window.console.log(rowData.Id)
    },
    //回调
    formCallBack(data) {
      this.formVisible = false;
      this.formVisibleQuery = false;
      if (data != null) {
        this.loadData();
      }
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 280;
      }
      return tableMaxHeight;
    },
      //改变分页大小
    handleSizeChange(val) {
      let that = this;
      that.currentPage = 1;
      that.pageSize = val;
      that.loadData();
    },
    //改变当前页码
    handleCurrentChange(val) {
      const vm = this
      if (vm.total > vm.pageSize) {
        vm.currentPage = val;
        vm.loadData();
      }
    },
  },
};
</script>

<style>
.hideButton .dialog-footer >>> .el-button--primary {
  display: none;
}
</style>
